import { axiosInstance } from "../config";

export default {
  state: {
    user: [],
    current_username: "",
  },
  mutations: {
    SetUser(state, payload) {
      state.user = payload;
    },
    SetCurrentUser(state, payload) {
      state.current_username = payload;
    },
  },
  actions: {
    async UserCkeck({ commit }) {
      if (
        !window.localStorage.getItem("userToken") &&
        !window.localStorage.getItem("token")
      ) {
        return;
      } else {
        return await axiosInstance
          .get(`/user/current`, {
            headers: {
              Authorization: `Bearer ${
                window.localStorage.getItem("userToken") ??
                window.localStorage.getItem("token")
              }`,
            },
          })
          .then(function (data) {
            commit("SetCurrentUser", data?.data.username);
            return data;
          })
          .catch(function (error) {
            return {
              error: error,
            };
          });
      }
      /* return await axiosInstance
        .get(`/user`)
        .then(function (data) {
          return data?.data?.success;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        }); */
    },
    async Get_Users({ commit }) {
      return await axiosInstance
        .get(`/user`)
        .then(function (data) {
          let sort_data = data?.data?.data.sort((a, b) => b.id - a.id);
          commit("SetUser", sort_data);
          return sort_data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Post_User_Register({}, payload) {
      return await axiosInstance
        .post("/user/register", payload)
        .then(function (data) {
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Post_User_Login({}, payload) {
      return await axiosInstance
        .post("/user/login", payload)
        .then(function (data) {
          localStorage.setItem("userToken", data?.data?.data?.token);
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Post_User_Logout({}, payload) {
      return await axiosInstance
        .post("/user/logout", payload)
        .then(function (data) {
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Post_User_Logout_Terminate({}, payload) {
      return await axiosInstance
        .post("/user/terminate", payload)
        .then(function (data) {
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Put_User_Update({}, payload) {
      return await axiosInstance
        .put(`/user/${payload.id}`, payload.data)
        .then(function (data) {
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Patch_User_change_password({}, payload) {
      return await axiosInstance
        .patch(`/user/${payload.id}/change_password`, payload.data)
        .then(function (data) {
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Patch_User_regenerate_password({}, payload) {
      return await axiosInstance
        .patch(`/user/${payload.id}/regenerate_password`)
        .then(function (data) {
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_User_by_ID(commit, payload) {
      return await axiosInstance
        .delete("/user/" + payload?.id)
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
  },
  getters: {
    get_user: (state) => state.user,
    get_current_username: (state) => state.current_username,
  },
};
